// extracted by mini-css-extract-plugin
export default {"product_img":"Product_product_img__ftRAT"};